(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/cache.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/cache.js');
"use strict";



const {
  browser: browserStorage,
  constants: storageConstants
} = svs.components.Storage;

const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const ONE_MINUTE = 60 * 1000;
const STORAGE_EXPIRE = 10 * ONE_MINUTE;

const STORAGE_DOMAIN_KEY = 'quickplay-react';
const STORAGE_KEEP_OPEN_ITEM = 'keepOpen';
const Global = Object.seal({
  hasBeenTested: false,
  hasPassedTests: false
});
_cleanupDomainAsync();

function getData(_ref) {
  let {
    itemKey
  } = _ref;
  try {
    if (_testAvailability()) {
      const key = "".concat(STORAGE_DOMAIN_KEY, ".").concat(itemKey);
      const json = sessionStorage.getItem(key);
      if (!json) {
        return null;
      }
      const {
        expireTS,
        data
      } = JSON.parse(json) || {};
      if (expireTS && Date.now() > expireTS) {
        sessionStorage.removeItem(key);
      } else {
        return data;
      }
    }
  } catch (error) {
    logger.info("Failed to read item in sessionStorage (\"".concat(error === null || error === void 0 ? void 0 : error.message, "\")"));
  }
  return null;
}

function setData(_ref2) {
  let {
    itemKey,
    data,
    ttl
  } = _ref2;
  try {
    if (_testAvailability()) {
      const key = "".concat(STORAGE_DOMAIN_KEY, ".").concat(itemKey);
      const json = JSON.stringify({
        expireTS: Date.now() + (ttl || STORAGE_EXPIRE),
        data
      });
      sessionStorage.setItem(key, json);
    }
  } catch (error) {
    logger.info("Failed to save item in sessionStorage (\"".concat(error === null || error === void 0 ? void 0 : error.message, "\")"));
  }
}

function unsetData(_ref3) {
  let {
    itemKey
  } = _ref3;
  try {
    if (_testAvailability()) {
      const key = "".concat(STORAGE_DOMAIN_KEY, ".").concat(itemKey);
      sessionStorage.removeItem(key);
    }
  } catch (error) {
    logger.info("Failed to remove item in sessionStorage (\"".concat(error === null || error === void 0 ? void 0 : error.message, "\")"));
  }
}
function reset() {
  Global.hasBeenTested = false;
}

function _testAvailability() {
  if (!Global.hasBeenTested) {
    Global.hasBeenTested = true;
    Global.hasPassedTests = false;
    try {
      const testKey = 'testsvsstorage';
      sessionStorage.setItem(testKey, testKey);
      sessionStorage.removeItem(testKey);
      Global.hasPassedTests = true;
    } catch (error) {
      logger.info('Write-test in sessionStorage failed - disabling cache');
    }
  }
  return Global.hasPassedTests;
}

async function _cleanupDomainAsync() {
  try {
    if (_testAvailability()) {
      const allItemKeys = Object.keys(sessionStorage).filter(key => key.startsWith("".concat(STORAGE_DOMAIN_KEY, ".")));
      await Promise.all(allItemKeys.map(async key => {
        const json = sessionStorage.getItem(key);
        if (!json) {
          return;
        }
        const {
          expireTS
        } = JSON.parse(json) || {};
        if (expireTS && Date.now() > expireTS) {
          sessionStorage.removeItem(key);
        }
      }));
    }
  } catch (error) {
    logger.info("Failed to cleanup items in sessionStorage (\"".concat(error === null || error === void 0 ? void 0 : error.message, "\")"));
  }
}

function setKeepOpen(_ref4) {
  let {
    branding,
    productId,
    drawNumber,
    hasSaveButton,
    systemCost,
    systemType,
    rowPrice,
    productSizes
  } = _ref4;
  const itemData = {
    branding,
    productId,
    drawNumber,
    hasSaveButton,
    systemCost,
    systemType,
    rowPrice,
    productSizes
  };
  browserStorage.set(STORAGE_KEEP_OPEN_ITEM, STORAGE_DOMAIN_KEY, {
    itemData
  }, storageConstants.EXPIRES_10M);
}
function unsetKeepOpen() {
  browserStorage.remove(STORAGE_KEEP_OPEN_ITEM, STORAGE_DOMAIN_KEY);
}

setGlobal('svs.components.sport.quickplayModal.cache', {
  getData,
  setData,
  unsetData,
  reset,
  setKeepOpen,
  unsetKeepOpen
});

 })(window);